import React from 'react';
import { AwardIcon, BookOpenIcon, HeartIcon, UsersIcon, GraduationCapIcon, SparklesIcon, ShieldCheckIcon, LeafIcon, BrainIcon, HandHeartIcon, StarIcon, TrophyIcon } from 'lucide-react';
export function AboutUs() {
  const coreValues = [{
    icon: HeartIcon,
    title: 'Patient-Centered Care',
    description: 'Every individual is unique, with personalized treatment tailored to specific needs and goals'
  }, {
    icon: ShieldCheckIcon,
    title: 'Prevention & Wellness',
    description: 'Emphasizing proactive health maintenance through lifestyle and preventive practices'
  }, {
    icon: BookOpenIcon,
    title: 'Evidence-Based Practice',
    description: 'Honoring traditional wisdom while validating approaches through clinical research'
  }, {
    icon: HandHeartIcon,
    title: 'Compassion & Respect',
    description: 'Healing in an environment of unconditional support and respect for each journey'
  }, {
    icon: GraduationCapIcon,
    title: 'Education & Empowerment',
    description: 'Empowering individuals with knowledge to make informed health decisions'
  }, {
    icon: UsersIcon,
    title: 'Integration & Collaboration',
    description: 'Bringing together diverse healthcare modalities for comprehensive patient care'
  }, {
    icon: SparklesIcon,
    title: 'Accessibility & Service',
    description: 'Making quality holistic healthcare accessible to all communities'
  }, {
    icon: LeafIcon,
    title: 'Continuous Learning',
    description: 'Committed to lifelong learning and staying current with medical advances'
  }, {
    icon: AwardIcon,
    title: 'Ethical Practice',
    description: 'Maintaining highest standards of professional ethics and patient welfare'
  }, {
    icon: BrainIcon,
    title: 'Mind-Body-Spirit',
    description: 'Recognizing the profound interconnection between mental, physical, and spiritual health'
  }];
  const education = [{
    degree: 'Ph.D. in Yoga and Naturopathy',
    institution: 'Monard University, Hapur, U.P.',
    detail: 'Groundbreaking case study on tongue diagnosis in Traditional Chinese Medicine'
  }, {
    degree: 'M.A.',
    institution: 'Shobhit University, Meerut',
    detail: ''
  }, {
    degree: 'B.A.',
    institution: 'Lucknow University',
    detail: ''
  }];
  const specializedTraining = [{
    category: 'Master Tung Acupuncture',
    trainers: 'Henry McCann, Brad Whisnant, Susan Johnson, Chuan-Min Wang',
    institution: 'Lotus Institute of Integrative Medicine, California'
  }, {
    category: 'Advanced TCM Tongue Diagnosis',
    trainers: 'Giovanni Maciocia',
    institution: ''
  }, {
    category: 'Pulse Energy Assessment',
    trainers: 'Dr. Jimmy Chang',
    institution: ''
  }, {
    category: 'Scalp Acupuncture',
    trainers: 'Karl C.H. Tai',
    institution: ''
  }, {
    category: 'Abdominal Acupuncture (Fu Zhen)',
    trainers: 'Dave Shipsey',
    institution: ''
  }, {
    category: "Jin's Three-Needle Technique",
    trainers: '',
    institution: ''
  }, {
    category: 'Cosmetic Acupuncture',
    trainers: 'Martha Lucas',
    institution: ''
  }, {
    category: 'Korean Cosmetic Acupuncture',
    trainers: 'Seung Choi',
    institution: ''
  }, {
    category: 'Fertility Acupuncture',
    trainers: 'Aaron Zizov',
    institution: ''
  }, {
    category: 'Auricular Medicine',
    trainers: 'Dr. Li Chun Huang',
    institution: ''
  }, {
    category: 'Pain Management',
    trainers: 'Dr. M.K. Sastry',
    institution: ''
  }, {
    category: 'Sujok & Advanced Sujok Therapy',
    trainers: 'Dr. Richa Varshnay',
    institution: ''
  }, {
    category: 'TCM Colour Therapy',
    trainers: 'Dr. Archana Dubey',
    institution: ''
  }];
  const achievements = ['Pioneered a Ph.D. thesis on TCM tongue diagnosis, contributing new clinical insights', "Established AETHE's flagship community-empowerment programs, reaching thousands with preventive health education", "Launched India's first comprehensive Master Tung and Balance Method certification series", 'Published clinical case studies on integrative approaches to diabetes management and stroke rehabilitation', 'Invited speaker at national integrative medicine symposiums on cosmetic acupuncture and fertility enhancement'];
  return <div className="w-full bg-white" data-id="element-105">
      <section className="bg-gradient-to-br from-blue-50 to-teal-50 py-16 px-4 w-full" data-id="element-106">
        <div className="max-w-7xl mx-auto text-center" data-id="element-107">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8eURTgVqvsP8mr9gqSQeVQ/Logos.png" alt="AETHE Logo" className="h-32 w-32 object-contain mx-auto mb-6" data-id="element-108" />
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-109">
            About AETHE.IN
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-110">
            A pioneering organization dedicated to advancing integrative
            medicine through clinical excellence and comprehensive education
          </p>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-111">
        <div className="max-w-7xl mx-auto" data-id="element-112">
          <div className="grid md:grid-cols-2 gap-12 items-start mb-16" data-id="element-113">
            <div className="sticky top-24" data-id="element-114">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mMwkFPmX25zYumMB8LyTEk/image.png" alt="Dr. Amit Kapoor" className="rounded-2xl shadow-2xl w-full" data-id="element-115" />
              <div className="mt-6 bg-gradient-to-br from-blue-50 to-teal-50 p-6 rounded-xl" data-id="element-116">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-117">
                  Dr. Amit Kapoor, Ph.D.
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-118">
                  Founder & Chief Practitioner
                </p>
                <div className="flex items-center text-sm text-gray-700" data-id="element-119">
                  <StarIcon className="w-5 h-5 text-yellow-500 fill-current mr-2" data-id="element-120" />
                  <span data-id="element-121">
                    Leading Acupuncturist & Integrative Medicine Expert
                  </span>
                </div>
              </div>
            </div>
            <div className="space-y-8" data-id="element-122">
              <div data-id="element-123">
                <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-124">
                  Professional Biography
                </h2>
                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-125">
                  Dr. Amit Kapoor, Ph.D., is a leading acupuncturist and
                  integrative medicine practitioner based in Lucknow, Uttar
                  Pradesh. He earned his doctorate in Yoga and Naturopathy from
                  Monard University, Hapur, U.P., with a groundbreaking case
                  study on tongue diagnosis in Traditional Chinese Medicine.
                </p>
                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-126">
                  With extensive training at the Lotus Institute of Integrative
                  Medicine (California) and under world-renowned experts, Dr.
                  Kapoor has dedicated his career to bridging ancient healing
                  wisdom with modern medical understanding. His approach
                  emphasizes treating the whole person—body, mind, and
                  spirit—recognizing that true healing occurs when all aspects
                  of an individual are brought into balance.
                </p>
              </div>
              <div data-id="element-127">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-128">
                  <GraduationCapIcon className="w-7 h-7 text-blue-600 mr-3" data-id="element-129" />
                  Education
                </h3>
                <div className="space-y-4" data-id="element-130">
                  {education.map((edu, index) => <div key={index} className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-600" data-id="element-131">
                      <h4 className="font-semibold text-gray-900" data-id="element-132">
                        {edu.degree}
                      </h4>
                      <p className="text-sm text-gray-700" data-id="element-133">{edu.institution}</p>
                      {edu.detail && <p className="text-sm text-gray-600 mt-2 italic" data-id="element-134">
                          {edu.detail}
                        </p>}
                    </div>)}
                </div>
              </div>
              <div data-id="element-135">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-136">
                  <AwardIcon className="w-7 h-7 text-teal-600 mr-3" data-id="element-137" />
                  Specialized Training & Certifications
                </h3>
                <div className="space-y-3" data-id="element-138">
                  {specializedTraining.map((training, index) => <div key={index} className="bg-teal-50 p-4 rounded-lg" data-id="element-139">
                      <h4 className="font-semibold text-gray-900 mb-1" data-id="element-140">
                        {training.category}
                      </h4>
                      {training.trainers && <p className="text-sm text-gray-700" data-id="element-141">
                          Trained by: {training.trainers}
                        </p>}
                      {training.institution && <p className="text-xs text-gray-600 mt-1" data-id="element-142">
                          {training.institution}
                        </p>}
                    </div>)}
                </div>
              </div>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-143">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl shadow-lg" data-id="element-144">
              <div className="flex items-center mb-6" data-id="element-145">
                <UsersIcon className="w-12 h-12 text-blue-600 mr-4" data-id="element-146" />
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-147">
                  Experience & Leadership
                </h3>
              </div>
              <div className="space-y-4" data-id="element-148">
                <div className="bg-white p-4 rounded-lg" data-id="element-149">
                  <h4 className="font-semibold text-gray-900 mb-2" data-id="element-150">
                    President & Founder
                  </h4>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-151">
                    Aatmshakti Empowerment Trust for Health and Education
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-152">
                    Champions community-based holistic health initiatives across
                    Uttar Pradesh, empowering communities with preventive health
                    education and natural healing practices.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg" data-id="element-153">
                  <h4 className="font-semibold text-gray-900 mb-2" data-id="element-154">Director</h4>
                  <p className="text-sm text-gray-700 mb-2" data-id="element-155">
                    Aatmshakti Institute of Integrated Medical Research
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-156">
                    Designs and leads advanced acupuncture and integrative
                    medicine courses, establishing the Institute as a premier
                    center for clinical training and research in alternative
                    therapies.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl shadow-lg" data-id="element-157">
              <div className="flex items-center mb-6" data-id="element-158">
                <TrophyIcon className="w-12 h-12 text-purple-600 mr-4" data-id="element-159" />
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-160">
                  Recognitions & Achievements
                </h3>
              </div>
              <div className="space-y-3" data-id="element-161">
                {achievements.map((achievement, index) => <div key={index} className="flex items-start bg-white p-3 rounded-lg" data-id="element-162">
                    <div className="w-2 h-2 bg-purple-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-163"></div>
                    <p className="text-sm text-gray-700" data-id="element-164">{achievement}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gray-50 w-full" data-id="element-165">
        <div className="max-w-7xl mx-auto" data-id="element-166">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-167">
            Organization Overview
          </h2>
          <div className="grid md:grid-cols-2 gap-12 mb-16" data-id="element-168">
            <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-169">
              <div className="flex items-center mb-6" data-id="element-170">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8eURTgVqvsP8mr9gqSQeVQ/Logos.png" alt="AETHE Logo" className="h-16 w-16 object-contain mr-4" data-id="element-171" />
                <div data-id="element-172">
                  <h3 className="text-2xl font-bold text-blue-600" data-id="element-173">AETHE</h3>
                  <p className="text-sm text-gray-600" data-id="element-174">
                    Aatmshakti Empowerment Trust for Health and Education
                  </p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-175">
                The Aatmshakti Empowerment Trust for Health and Education serves
                as the foundation for community health empowerment and holistic
                wellness education. Drawing its name from "Aatmshakti"—meaning
                "power of the soul"—the Trust embodies the belief that true
                healing begins from within and that each individual possesses
                innate healing powers.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-176">
                AETHE focuses on making Traditional Chinese Medicine,
                acupuncture, acupressure, and complementary therapies accessible
                to communities throughout India. Through public education
                initiatives, community health programs, and awareness campaigns,
                the Trust works to empower individuals with knowledge about
                natural healing modalities that complement conventional medical
                care.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-177">
              <div className="flex items-center mb-6" data-id="element-178">
                <GraduationCapIcon className="h-16 w-16 text-teal-600 mr-4" data-id="element-179" />
                <div data-id="element-180">
                  <h3 className="text-2xl font-bold text-teal-600" data-id="element-181">AIIMR</h3>
                  <p className="text-sm text-gray-600" data-id="element-182">
                    Aatmshakti Institute of Integrated Medical Research
                  </p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-183">
                The Aatmshakti Institute of Integrated Medical Research stands
                as a premier educational institution dedicated to training
                healthcare professionals in integrative medicine modalities. As
                the sister concern of AETHE, AIIMR translates the Trust's vision
                into practical education and clinical training.
              </p>
              <p className="text-gray-700 leading-relaxed" data-id="element-184">
                AIIMR offers comprehensive courses designed by industry experts
                and experienced practitioners, covering various aspects of
                Traditional Chinese Medicine, acupuncture techniques, and
                complementary therapies. The Institute emphasizes evidence-based
                practice while honoring traditional healing wisdom, preparing
                practitioners who can integrate multiple therapeutic approaches
                to provide comprehensive, patient-centered care.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-185">
        <div className="max-w-7xl mx-auto" data-id="element-186">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-187">
            Mission & Vision
          </h2>
          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-188">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-2xl" data-id="element-189">
              <HeartIcon className="w-12 h-12 text-blue-600 mb-4" data-id="element-190" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-191">
                Our Mission
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-192">
                To empower individuals and communities with accessible,
                evidence-based integrative healthcare education and treatment
                that honors traditional healing wisdom while embracing modern
                medical understanding, creating a healthier, more balanced
                society where holistic wellness is a fundamental right, not a
                privilege.
              </p>
              <div className="space-y-3 mt-6" data-id="element-193">
                <div className="flex items-start" data-id="element-194">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-195"></div>
                  <p className="text-gray-700 text-sm" data-id="element-196">
                    Education Excellence: World-class training in TCM and
                    integrative therapies
                  </p>
                </div>
                <div className="flex items-start" data-id="element-197">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-198"></div>
                  <p className="text-gray-700 text-sm" data-id="element-199">
                    Clinical Excellence: Patient-centered care treating the
                    whole person
                  </p>
                </div>
                <div className="flex items-start" data-id="element-200">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-201"></div>
                  <p className="text-gray-700 text-sm" data-id="element-202">
                    Community Empowerment: Accessible holistic healthcare
                    knowledge
                  </p>
                </div>
                <div className="flex items-start" data-id="element-203">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-204"></div>
                  <p className="text-gray-700 text-sm" data-id="element-205">
                    Research & Innovation: Advancing integrative medicine
                    through clinical research
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-8 rounded-2xl" data-id="element-206">
              <UsersIcon className="w-12 h-12 text-teal-600 mb-4" data-id="element-207" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-208">
                Our Vision
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-209">
                To be recognized as a leading force in integrative medicine
                education and practice in India, where Traditional Chinese
                Medicine and complementary therapies are fully integrated into
                mainstream healthcare, and where every individual has access to
                healing modalities that treat them as whole persons rather than
                collections of symptoms.
              </p>
              <div className="space-y-3 mt-6" data-id="element-210">
                <div className="flex items-start" data-id="element-211">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-212"></div>
                  <p className="text-gray-700 text-sm" data-id="element-213">
                    A healthcare landscape considering all dimensions of health
                    equally
                  </p>
                </div>
                <div className="flex items-start" data-id="element-214">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-215"></div>
                  <p className="text-gray-700 text-sm" data-id="element-216">
                    Communities empowered with natural healing practices
                    knowledge
                  </p>
                </div>
                <div className="flex items-start" data-id="element-217">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-218"></div>
                  <p className="text-gray-700 text-sm" data-id="element-219">
                    New generation of practitioners with scientific rigor and
                    compassion
                  </p>
                </div>
                <div className="flex items-start" data-id="element-220">
                  <div className="w-2 h-2 bg-teal-600 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-221"></div>
                  <p className="text-gray-700 text-sm" data-id="element-222">
                    Recognition of TCM as essential comprehensive healthcare
                    component
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-gray-50 to-blue-50 w-full" data-id="element-223">
        <div className="max-w-7xl mx-auto" data-id="element-224">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-225">
            Our Brand & Identity
          </h2>
          <div className="max-w-4xl mx-auto mb-12" data-id="element-226">
            <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-227">
              <div className="flex flex-col md:flex-row items-center gap-8 mb-8" data-id="element-228">
                <div className="flex-shrink-0" data-id="element-229">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8eURTgVqvsP8mr9gqSQeVQ/Logos.png" alt="AETHE Logo" className="h-32 w-32 object-contain" data-id="element-230" />
                </div>
                <div data-id="element-231">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-232">
                    Our Guiding Principles
                  </h3>
                  <div className="space-y-3" data-id="element-233">
                    <p className="text-lg font-semibold text-blue-600" data-id="element-234">
                      "Empowering Holistic Health Through Integrative Wisdom"
                    </p>
                    <p className="text-lg font-semibold text-teal-600" data-id="element-235">
                      "Tradition Meets Transformation"
                    </p>
                    <p className="text-lg font-semibold text-purple-600" data-id="element-236">
                      "Healing Hands, Informed Minds"
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-8" data-id="element-237">
                <div className="bg-gradient-to-br from-blue-50 to-teal-50 p-6 rounded-xl" data-id="element-238">
                  <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-239">
                    AIIMR Emblem
                  </h4>
                  <p className="text-gray-700 leading-relaxed" data-id="element-240">
                    Two cupped hands cradling an open book motif beneath a
                    rising sun and academic cap, encircled by the institute's
                    name. This symbol represents our commitment to education,
                    nurturing knowledge, and the dawn of new understanding in
                    integrative medicine.
                  </p>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-6 rounded-xl" data-id="element-241">
                  <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-242">
                    AETHE Seal
                  </h4>
                  <p className="text-gray-700 leading-relaxed" data-id="element-243">
                    Stylized hands framing a graduation cap over a radiant core,
                    with the trust's name and registration number. This emblem
                    embodies empowerment, education, and the healing energy that
                    flows from the soul—our Aatmshakti.
                  </p>
                </div>
              </div>
              <div className="mt-8 bg-gradient-to-r from-blue-600 via-teal-600 to-purple-600 p-6 rounded-xl text-white" data-id="element-244">
                <h4 className="text-xl font-bold mb-4" data-id="element-245">Our Color Philosophy</h4>
                <div className="grid md:grid-cols-2 gap-4" data-id="element-246">
                  <div data-id="element-247">
                    <div className="flex items-center mb-2" data-id="element-248">
                      <div className="w-6 h-6 bg-blue-700 rounded mr-3" data-id="element-249"></div>
                      <span className="font-semibold" data-id="element-250">Deep Blue</span>
                    </div>
                    <p className="text-sm text-blue-50 ml-9" data-id="element-251">
                      Trust & Stability
                    </p>
                  </div>
                  <div data-id="element-252">
                    <div className="flex items-center mb-2" data-id="element-253">
                      <div className="w-6 h-6 bg-teal-500 rounded mr-3" data-id="element-254"></div>
                      <span className="font-semibold" data-id="element-255">Turquoise/Teal</span>
                    </div>
                    <p className="text-sm text-blue-50 ml-9" data-id="element-256">
                      Healing & Balance
                    </p>
                  </div>
                  <div data-id="element-257">
                    <div className="flex items-center mb-2" data-id="element-258">
                      <div className="w-6 h-6 bg-orange-500 rounded mr-3" data-id="element-259"></div>
                      <span className="font-semibold" data-id="element-260">Sunrise Orange</span>
                    </div>
                    <p className="text-sm text-blue-50 ml-9" data-id="element-261">
                      Energy & Renewal
                    </p>
                  </div>
                  <div data-id="element-262">
                    <div className="flex items-center mb-2" data-id="element-263">
                      <div className="w-6 h-6 bg-purple-600 rounded mr-3" data-id="element-264"></div>
                      <span className="font-semibold" data-id="element-265">Purple</span>
                    </div>
                    <p className="text-sm text-blue-50 ml-9" data-id="element-266">
                      Wisdom & Compassion
                    </p>
                  </div>
                </div>
                <p className="text-sm text-blue-50 mt-4 italic" data-id="element-267">
                  This palette reflects integrative medicine's blend of
                  time-honored practice with renewed vitality, conveying both
                  professionalism and holistic warmth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 w-full" data-id="element-268">
        <div className="max-w-7xl mx-auto" data-id="element-269">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-270">
            Core Philosophy
          </h2>
          <div className="max-w-4xl mx-auto mb-12" data-id="element-271">
            <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-272">
              <h3 className="text-2xl font-semibold text-blue-600 mb-4" data-id="element-273">
                Our Holistic Philosophy
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4" data-id="element-274">
                Our work is grounded in the holistic medicine philosophy that
                health represents a dynamic state of balance and harmony within
                the body and mind, not merely the absence of disease. This
                perspective aligns with the World Health Organization's
                definition recognizing health as complete physical, mental, and
                social well-being.
              </p>
              <div className="grid md:grid-cols-3 gap-6 mt-8" data-id="element-275">
                <div className="text-center p-4" data-id="element-276">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-277">
                    <UsersIcon className="w-8 h-8 text-blue-600" data-id="element-278" />
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2" data-id="element-279">
                    Whole-Person Approach
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-280">
                    Treating the complete person, addressing all interconnected
                    aspects
                  </p>
                </div>
                <div className="text-center p-4" data-id="element-281">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-282">
                    <BookOpenIcon className="w-8 h-8 text-teal-600" data-id="element-283" />
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2" data-id="element-284">
                    Integration of Tradition & Science
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-285">
                    Combining conventional medicine with time-honored practices
                  </p>
                </div>
                <div className="text-center p-4" data-id="element-286">
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-287">
                    <SparklesIcon className="w-8 h-8 text-purple-600" data-id="element-288" />
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2" data-id="element-289">
                    Innate Healing Capacity
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-290">
                    Supporting the body's natural ability to heal itself
                  </p>
                </div>
              </div>
            </div>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-291">
            Our Core Values
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-292">
            {coreValues.map((value, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow" data-id="element-293">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-teal-100 rounded-lg flex items-center justify-center mb-4" data-id="element-294">
                  <value.icon className="w-6 h-6 text-blue-600" data-id="element-295" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-296">
                  {value.title}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-297">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}